<template>
  <div class="list_container">
    <swiper :options="{slidesPerView: slidesPerView, spaceBetween: spaceBetween,slidesOffsetAfter: 20}" ref="mySwiper">
      <swiper-slide class="list_item" v-for="(item,index) in array" :key="index">
        <div @click="itemClick($event,item.id,item)">
          <van-image radius="3px" :width="imageWidth" :height="imageHeight" lazy-load :src="isRecommend?item.imageUrl:item.imgUrl" />
          <slot name="bottom_container">
            <slot name="title" :item="item">
              <div class="title">{{item.title}}</div>
            </slot>
            <slot name="date" :item="item">
              <div class="date">{{item.gameTime}}</div>
            </slot>
            <slot name="address" :item="item">
              <div class="address">{{item.localField?item.localField:'未知'}}</div>
            </slot>
            <slot name="tags" :item="item">
              <div class="tags_container" v-if="item.tags">
                <div class="tags">{{item.tags}}</div>
              </div>
            </slot>
            <slot name="state" :item="item">

            </slot>
            <slot name="label" :item="item">
              <div class="label_component">#{{item.typeStr}}</div>
            </slot>
          </slot>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "list-topImg",
  data() {
    return {

    };
  },
  props: {
    isRecommend: {
      default: () => { return false },
      type: Boolean
    },
    // 数据源
    array: {
      default: () => { return [] },
      type: Array
    },
    // 控制item的显示数量
    slidesPerView: {
      default: () => { return 2 },
      type: Number
    },
    // item 之间间隔
    spaceBetween: {
      default: () => { return 0 },
      type: Number
    },
    // 图片宽度
    imageWidth: {
      default: () => { return '100%' },
      // type: Number
    },
    // 图片高度
    imageHeight: {
      default: () => { return 100 },
      type: Number
    },
  },
  methods: {
    // item点击事件
    itemClick(event, id, item) {
      this.$emit('itemClick', id, item);
    }
  },
  computed: {},
  filters: {
    // 根据contentType判断名片类型
    isType(val) {
      if (val == 2) {
        return '景区';
      }
      if (val == 3) {
        return '景点';
      }
      if (val == 7) {
        return '咨询';
      }
      if (val == 8) {
        return '赛事';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list_container {
  .title {
    font-size: 13px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .date,
  .address {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 4px;
  }
  .label_component {
    font-size: 11px;
    color: #2eba73;
    margin-top: 4px;
  }
  .tags_container {
    display: flex;
    .tags {
      margin-right: 3px;
      padding: 1px 3px;
      background: rgba(0, 0, 0, 0.05);
      color: #787878;
      font-size: 11px;
    }
  }
}
</style>
